import React from "react"
import {
  TableBody,
  TableContainer,
  TableHeader,
  TableHeaderCell,
  TableRow,
  TableRowCell,
} from "containers/Table"
import { ArchiveRequest } from "./index"

const UserInfoRequestsLoading = () => (
  <TableContainer>
    <TableHeader loading>
      <TableHeaderCell>Camp Name</TableHeaderCell>
      <TableHeaderCell>City & State</TableHeaderCell>
      <TableHeaderCell>Description</TableHeaderCell>
      <TableHeaderCell>Archived?</TableHeaderCell>
    </TableHeader>
    <TableBody>
      {[1, 2, 3].map((row, i) => (
        <TableRow key={i} loading>
          <TableRowCell>Data</TableRowCell>
          <TableRowCell>Data</TableRowCell>
          <TableRowCell>Data</TableRowCell>
          <TableRowCell>
            <ArchiveRequest>Cancel Request</ArchiveRequest>
          </TableRowCell>
        </TableRow>
      ))}
    </TableBody>
  </TableContainer>
)

export default UserInfoRequestsLoading



// WEBPACK FOOTER //
// ./src/scenes/User/UserInfoRequests/UserInfoRequests.loading.js